/** TanStack Query hooks for GIS import tracking. */

import { useQuery } from '@tanstack/react-query'
import { getImportSummary } from '../api/imports.ts'

/** Imports summary — supplies the "model data synced" date for the AsOfStamp
 *  caption (spec A6 / §3.4). The queryKey matches DiscrepancyDashboard's
 *  inline ['import-summary'] query, so every stamp mount dedupes into the
 *  SAME cache entry instead of refetching per panel. */
export function useImportsSummary() {
  return useQuery({
    queryKey: ['import-summary'],
    queryFn: getImportSummary,
    staleTime: 30_000,
  })
}
